import {cva} from 'class-variance-authority';
import * as React from 'react';
import {twMerge} from 'tailwind-merge';

type Variant = 'primary' | 'destructive' | 'ghost' | 'outline';
type Size = 'icon' | 'default';
const variants = cva(
  ['flex items-center justify-center shadow-xs transition cursor-pointer'],
  {
    variants: {
      variant: {
        primary: 'bg-primary text-primary-foreground hover:bg-primary/80',
        destructive:
          'dark:bg-destructive/60 dark:hover:bg-destructive/80 bg-destructive text-white hover:bg-destructive/80',
        ghost: 'bg-transparent text-foreground hover:bg-accent shadow-none',
        outline: 'border border-input text-foreground hover:bg-accent/30',
      },
      disabled: {
        true: 'opacity-50 pointer-events-none',
      },
      size: {
        icon: 'rounded-full p-2.5',
        default: 'rounded-md px-4 py-2',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  },
);
type Props = React.ComponentPropsWithRef<'button'> & {
  variant?: Variant;
  size?: Size;
};
export const Button = React.forwardRef(
  (props: Props, ref: React.Ref<HTMLButtonElement>) => {
    const {variant, size, type, className, disabled, ...otherProps} = props;
    const baseClassName = variants({variant, size, disabled});
    const mergedClassName = twMerge(baseClassName, className);
    return (
      <button
        ref={ref}
        type={type || 'button'}
        className={mergedClassName}
        disabled={disabled}
        {...otherProps}
      />
    );
  },
);
